"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAppointmentSchema = makeAppointmentSchema;
function makeAppointmentSchema(params) {
    const { disablePast, disableFuture, isRequired } = params;
    const appointmentSchema = {
        type: "object",
        validateTimeRange: true,
        properties: {
            visitDate: {
                type: "number",
                format: "date",
                disablePast: !!disablePast,
                disableFuture: !!disableFuture,
            },
            visitStartTime: {
                type: "number",
                format: "time",
            },
            visitEndTime: {
                type: "number",
                format: "time",
            },
            isError: {
                type: "boolean",
            },
            isConflictAllowed: {
                type: "boolean",
            },
        },
    };
    if (isRequired)
        appointmentSchema.required = ["visitDate"];
    return appointmentSchema;
}
